<template>
  <!-- addBatchNote Modal -->
  <div
    class="modal fade"
    id="addBatchNoteModal"
    tabindex="-1"
    aria-labelledby="addBatchNoteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addBatchNoteModalLabel">
            Archivist's Batch Note
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeBatchNote"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <textarea
              v-model="message"
              class="form-control"
              rows="6"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="closeBatchNote"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="addBatchNote"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- deleteBatchNote Modal -->
  <div
    class="modal fade"
    id="deleteBatchNoteModal"
    tabindex="-1"
    aria-labelledby="deleteBatchNoteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteBatchNoteModalLabel">
            Delete Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">Are you sure you want to delete note?</div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="deleteBatchNote"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import GlobalData from "@/GlobalData";
import { useTransferStore } from "@/stores/content_review/transfer";
import { ref, watch } from "vue";

const transferId = ref();
const sipId = ref();
const transferStore = useTransferStore();
const message = ref("");

const props = defineProps({
  transferId: { type: String, required: true },
});

watch(
  () => props.transferId,
  (val) => {
    transferId.value = val;
  }
);

const addBatchNote = () => {
  transferStore.transferNote(props.transferId, message.value);
  message.value = "";
  // GlobalData.getInstance().sipNoteAdded.value = true;
};

const deleteBatchNote = () => {
  transferStore.deleteBatchNote(props.transferId);
};

const closeBatchNote = () => {
  message.value = "";
};
</script>
